import React from 'react';
import {Box} from '@material-ui/core';
import {openPopupWindow} from '../../../../../emitters/popup';
import {API_URL_HOST} from '../../../../../config/api';
import {STORAGE_API} from '../../../../../constants/localStorage';
import {MerchantInput} from '../../../../helpers/InputsHelpers';
import {FormWrapper, SubmitBtnMerchant} from '../../../../helpers/FormHandlers';
import Popup from '../../../../dumb/Popup/C';

module.exports = () => openPopupWindow(() => {
  return () => {
    return (
      <Popup
        caption="Change Api"
      >
        <FormWrapper
          data={{hostname: API_URL_HOST}}
          onResult={(res) => {
            localStorage.setItem(STORAGE_API, res.hostname);
            window.location.reload();
          }}
        >{(formCtx) => {
          return (
            <>
              <Box my="2.5rem">
                <MerchantInput
                  name="hostname"
                  formCtx={formCtx}
                />
              </Box>
              <Box mb="-3rem">
                <SubmitBtnMerchant
                  formCtx={formCtx}
                >
                  Change hostname
                </SubmitBtnMerchant>
              </Box>
            </>
          )
        }}</FormWrapper>
      </Popup>
    );
  };
});
